module.exports = __webpack_public_path__ + "static/media/main-large-section-1.df925b4b.png";